<script setup lang="ts">
import { onMounted, inject } from "vue";
import DashboardCardDO = App.Data.DashboardCardDO;
import { derivedDocumentKey } from "@/modules/explorer/ExplorerUtils";

const emit = defineEmits(["update:isLoading", "update:derivedDocument"]);

const derivedDocument = inject(derivedDocumentKey);

const props = defineProps<{
	card: DashboardCardDO;
}>();

onMounted(() => {
	if (props.card) {
		emit("update:isLoading", false);
		// BE updates activeDocument with the used document for rendering
		emit("update:derivedDocument", props.card.stored_document.activeDocument);
	}
});
</script>

<template>
	<img
		v-if="card.image_url"
		:src="card.image_url"
		:style="`width: ${card.image_width}px; height: ${card.image_height}px;`"
		alt="Graph image"
	/>
	<div class="h-100 no-data-empty-state">
		<v-empty-state
			icon="fa-duotone fa-cloud-binary"
			title="No data for this configuration"
			text="No data available for the period selection and/or selected filters."
		/>
	</div>
</template>

<style scoped lang="scss"></style>
